import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6hnsueepn: FaireProductEntity = {
  token: "p_y6hnsueepn",
  type: "product",
  name: "GAME DAY Letter Charm Station Necklace",
  brandToken: "b_c3xmn96nkh",
  brandName: "Sensibling Corp.",
  imageUrl: "https://cdn.faire.com/fastly/4ce22d18d00b515eb6786a2d66f2167c6d62e14929549d8eb12a6000dc6e36f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b97b33023385b91a02b798c3d330821e1d69d00af6140fcc1dce910abd774ae.jpeg",
    "https://cdn.faire.com/fastly/9d8e86f63cd048312904eb40e7cef3d299031190bb78d1c65f905fce52ea6891.jpeg",
    "https://cdn.faire.com/fastly/ace9207617cdb5500c269146232e6d2c9c98a8c8b6f479d7033cec874e0f14c0.jpeg",
    "https://cdn.faire.com/fastly/f1eb40a3269887eb6b2739c5246315ec01ac2c4f3fa865a1df79172a28c6da73.jpeg",
    "https://cdn.faire.com/fastly/27ff4c132e5c112cdade8b3760168d957f63d839813cad63d3ac56c0d9ad23c8.jpeg",
    "https://cdn.faire.com/fastly/2d110d1f6e0b427da81278177a3fe1751c8bd92d7c6481314dc6985088c5176c.jpeg",
    "https://cdn.faire.com/fastly/f2d821b92261b3e04f50a27313efe5bf0a1944f5dfb0f6bbf0465b85333e3ed9.jpeg",
    "https://cdn.faire.com/fastly/df4d7865c72cd68592a91d968cc9455586270d9caeff8b99bc1f5a27610030f0.jpeg",
    "https://cdn.faire.com/fastly/5f54ee589ee9197177bf96df47cdd0f546d361cd922a131dc5e6661966444907.jpeg",
    "https://cdn.faire.com/fastly/9fa39900bf8d1041c63d9fe486e1fc703a6a43165ffc122e01059e812a28f6c9.jpeg",
    "https://cdn.faire.com/fastly/6f51f0d8d86a063d4b189f298c74335896bba09933d9d391beb3cb168fe04ae0.jpeg",
    "https://cdn.faire.com/fastly/94ec21e9f6fbcc3835f869a53400d44904bdb3d8208c2b94f1c61449c53e6a50.jpeg",
    "https://cdn.faire.com/fastly/eb05d64cbb6b54281ed81f8d1b115b8ef182b021816dcefa81b0c8612f436045.jpeg",
    "https://cdn.faire.com/fastly/8653dbc72eafd554536ea01533b20848a18b54c86fa0dd8ea7512ffcda39e545.jpeg",
    "https://cdn.faire.com/fastly/f91ab5b82d890be60924279c2e32f6d710b1b9a8a7ae698e4213d7742301e023.jpeg",
    "https://cdn.faire.com/fastly/90afee9e135795da620fda1100d410d77ee13d8165c9c5c2bdf74a071ffbacad.jpeg",
    "https://cdn.faire.com/fastly/12ac9af51a48ea534d4f4378f5726e47401d8f079e441e3b7a9b4aef475bb213.jpeg",
    "https://cdn.faire.com/fastly/d11ba858455c484903bfc633ded78c479694e67f9d1e8405d293756693830ea8.jpeg",
    "https://cdn.faire.com/fastly/ccd6bc48231633eb1f012302b42ce43ed6272edcebbb3c3a60f9a33bb8153328.jpeg",
    "https://cdn.faire.com/fastly/f1a776b3c485bd0650a504c4a87136a05d859acc4a30d3b6fe6001b9b2306bb8.jpeg",
    "https://cdn.faire.com/fastly/a7ef47f27a83855b5567258da6fdcbf88f73af8d376ac9d6288deb6ed5f43a58.jpeg"
  ],
  priceDollars: 11.43,
  description: "Necklace Size : 18\" + 3\" L\r\nDecor Size : 1\" L\r\nCelebrate your team spirit with this game day necklace featuring bold letter charms and playful accent pieces. A perfect accessory to complete your spirited outfit for sporting events, tailgates, or fan gatherings.\nLead and Nickel Compliant\n",
  tags: [],
  msrpDollars: 22.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:53.260Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
